import {MANAGE_PROJECT_PERMISSION, PROJECT_STATUS} from '../../../utils/constant';
import authenticationService from '../../../services/authentication/AuthenticationService';

export const shouldDisplayInformationMessage = (project = {}) => (
  project.projectStatus === PROJECT_STATUS.ACTIVE &&
  authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION)
);
